/**
 * Didactijuegos - La Máquina de Regalos
 * Shopify Edition
 */

class GiftMachine {
    constructor(sectionId) {
        this.section = document.getElementById(`gm-${sectionId}`);
        if (!this.section) return;

        this.flow = ['start', 'age', 'gender', 'budget', 'occasion', 'loading', 'results'];
        this.progressMap = { 'age': 25, 'gender': 50, 'budget': 75, 'occasion': 100 };
        this.currentStepIndex = 0;
        this.historyTracker = [];
        this.selections = {};
        
        // Results caching
        this.resultsCache = [];
        this.resultsRenderedCount = 0;
        this.resultsMaxLoads = 5;
        this.resultsLoadCount = 0;

        this.init();
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        // Triggers can be inside or outside the section (e.g. Hero Slider)
        document.querySelectorAll('[data-gm-start]').forEach(el => {
            el.addEventListener('click', (e) => {
                if (el.getAttribute('href') === '#') e.preventDefault();
                this.startQuiz();
            });
        });

        this.section.querySelectorAll('[data-gm-back]').forEach(el => {
            el.addEventListener('click', () => this.goBack());
        });

        this.section.querySelectorAll('[data-gm-restart]').forEach(el => {
            el.addEventListener('click', () => this.restart());
        });

        const btnLoadMore = this.section.querySelector('#gm-btn-load-more');
        if (btnLoadMore) {
            btnLoadMore.addEventListener('click', () => this.renderMoreResults());
        }

        const btnBackToResults = this.section.querySelector('#gm-btn-back-to-results');
        if (btnBackToResults) {
            btnBackToResults.addEventListener('click', () => this.hideDetailScreen());
        }

        this.section.querySelectorAll('.opt-card').forEach(el => {
            el.addEventListener('click', (e) => {
                const category = el.dataset.category;
                const value = el.dataset.value;
                this.selectOption(category, value, el);
            });
        });

        // Add to cart buttons
        this.section.querySelectorAll('.btn-buy').forEach(el => {
            el.addEventListener('click', (e) => {
                const variantId = el.dataset.variantId;
                if (variantId) {
                    this.addToCart(variantId);
                }
            });
        });
    }

    getStepId(idx) { return this.flow[idx]; }

    showStep(targetIdx, direction = 'forward') {
        const prevId = this.getStepId(this.currentStepIndex);
        const nextId = this.getStepId(targetIdx);

        const prevEl = this.section.querySelector(`#screen-${prevId}`);
        const nextEl = this.section.querySelector(`#screen-${nextId}`);

        if (!nextEl) return;

        // Animation prep
        nextEl.style.transform = direction === 'forward' ? 'translateX(40px)' : 'translateX(-40px)';
        nextEl.offsetHeight; // reflow
        nextEl.style.transform = '';

        if (prevEl) {
            prevEl.classList.remove('active');
            if (direction === 'forward') {
                prevEl.classList.add('exit');
                setTimeout(() => prevEl.classList.remove('exit'), 320);
            } else {
                // Return animation
            }
        }
        nextEl.classList.add('active');

        // Progress Header
        const header = this.section.querySelector('#gm-progress-header');
        if (targetIdx > 0 && targetIdx < 5) {
            header.classList.add('visible');
            const label = this.section.querySelector('#gm-step-label');
            if (label) label.textContent = `PASO ${targetIdx} DE 4`;

            const fill = this.section.querySelector('#gm-pb-fill');
            if (fill) {
                const pct = this.progressMap[nextId];
                fill.style.width = pct + '%';
            }

            if (direction === 'forward') {
                setTimeout(() => this.spawnSparkles(), 600);
            }
        } else {
            if (header) header.classList.remove('visible');
        }

        this.currentStepIndex = targetIdx;
    }

    spawnSparkles() {
        const container = this.section.querySelector('#gm-sparkles-container');
        if (!container) return;
        
        container.innerHTML = '';
        for (let i = 0; i < 6; i++) {
            const sp = document.createElement('div');
            sp.className = 'sparkle';
            const tx = (Math.random() - 0.5) * 60 + 'px';
            const ty = (Math.random() - 0.5) * 60 + 'px';
            sp.style.setProperty('--tx', tx);
            sp.style.setProperty('--ty', ty);
            sp.style.animation = `popSparkle 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) ${Math.random() * 0.15}s forwards`;
            container.appendChild(sp);
        }
    }

    startQuiz() {
        this.historyTracker = [0, 1];
        this.showStep(1);
        
        // Scroll to machine with offset for header
        const offset = 80;
        const bodyRect = document.body.getBoundingClientRect().top;
        const elementRect = this.section.getBoundingClientRect().top;
        const elementPosition = elementRect - bodyRect;
        const offsetPosition = elementPosition - offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }

    goBack() {
        if (this.historyTracker.length > 1) {
            this.historyTracker.pop();
            const prevIdx = this.historyTracker[this.historyTracker.length - 1];
            this.showStep(prevIdx, 'back');
        } else {
            this.showStep(0, 'back');
        }
    }

    selectOption(category, val, el) {
        const grid = el.closest('.options-grid');
        grid.querySelectorAll('.opt-card').forEach(c => c.classList.remove('selected'));
        el.classList.add('selected');

        this.selections[category] = val;

        setTimeout(() => {
            const nextIdx = this.currentStepIndex + 1;
            this.historyTracker.push(nextIdx);
            if (nextIdx === 5) {
                this.showStep(5);
                this.doLoading();
            } else {
                this.showStep(nextIdx);
            }
        }, 250);
    }

    doLoading() {
        const msgs = [
            "Analizando parámetros...",
            "Cruzando variables pedagógicas...",
            "Identificando el regalo perfecto..."
        ];
        let m = 0;
        const sub = this.section.querySelector('#gm-loader-sub');
        if (sub) sub.textContent = msgs[0];

        const intv = setInterval(() => {
            m++;
            if (m < msgs.length) {
                if (sub) {
                    sub.style.opacity = 0;
                    setTimeout(() => { sub.textContent = msgs[m]; sub.style.opacity = 1; }, 300);
                }
            } else {
                clearInterval(intv);
                this.showStep(6);
                this.fetchRecommendedProducts();
            }
        }, 1600);
    }

    fetchRecommendedProducts() {
        console.log("Selections made:", this.selections);
        const container = this.section.querySelector('#gm-results-container');
        if (container) {
            container.innerHTML = '<div style="grid-column: 1/-1; text-align: center; padding: 40px; color: #6B7280;">Buscando en nuestro inventario...</div>';
        }

        // Build Search Query based on answers
        let query = "";
        
        // Age mapping
        const age = this.selections.age;
        if (age === '0-12m') query += "bebé ";
        else if (age === '1-3a') query += "1 3 años ";
        else if (age === '3-6a') query += "3 6 años ";
        else if (age === '6-12a') query += "6 12 años ";

        // Occasion mapping (optional)
        const occasion = this.selections.occasion;
        if (occasion === 'nacimiento' && age !== '0-12m') query += "bebé ";

        let searchUrl = `/search?q=${encodeURIComponent(query)}*&type=product`;

        // Budget mapping
        const budget = this.selections.budget;
        if (budget === '300-500') {
            searchUrl += `&filter.v.price.gte=300&filter.v.price.lte=500`;
        } else if (budget === '500-900') {
            searchUrl += `&filter.v.price.gte=500&filter.v.price.lte=900`;
        } else if (budget === '900+') {
            searchUrl += `&filter.v.price.gte=900`;
        }

        console.log("Fetching from:", searchUrl);

        fetch(searchUrl)
            .then(res => res.text())
            .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                
                // We use the new dj-product-card from the premium search page
                const productCards = doc.querySelectorAll('.dj-product-card');
                
                if (container) {
                    container.innerHTML = '';
                    this.resultsCache = Array.from(productCards);
                    this.resultsRenderedCount = 0;
                    this.resultsLoadCount = 0;

                    if (this.resultsCache.length > 0) {
                        this.renderMoreResults();
                    } else {
                        container.innerHTML = '<div style="grid-column: 1/-1; text-align: center; padding: 40px; color: #6B7280; font-family: var(--font); font-size: 16px;">No se encontraron tesoros con esta combinación. ¡Intenta con otras opciones!</div>';
                        const loadMoreContainer = this.section.querySelector('#gm-load-more-container');
                        if (loadMoreContainer) loadMoreContainer.style.display = 'none';
                    }
                }
            })
            .catch(err => {
                console.error("Error fetching recommended products:", err);
                if (container) {
                    container.innerHTML = '<div style="grid-column: 1/-1; text-align: center; padding: 40px; color: #EF4444; font-family: var(--font); font-size: 16px;">Ocurrió un error al buscar los regalos.</div>';
                }
            });
    }

    renderMoreResults() {
        const container = this.section.querySelector('#gm-results-container');
        const loadMoreContainer = this.section.querySelector('#gm-load-more-container');
        const resultsCountText = this.section.querySelector('#gm-results-count-text');
        
        if (!container) return;

        // Render up to 3 more
        const countToRender = 3;
        const start = this.resultsRenderedCount;
        const end = Math.min(start + countToRender, this.resultsCache.length);

        for (let i = start; i < end; i++) {
            const card = this.resultsCache[i];
            
            // Extract data
            const imgEl = card.querySelector('.dj-card-image img');
            const imgSrc = imgEl ? imgEl.src : '';
            const titleEl = card.querySelector('.dj-card-title a');
            const title = titleEl ? titleEl.textContent : '';
            const url = titleEl ? titleEl.href : '#';
            const vendorEl = card.querySelector('.dj-card-vendor');
            const vendor = vendorEl ? vendorEl.textContent : '';
            const priceEl = card.querySelector('.dj-card-price');
            const priceHtml = priceEl ? priceEl.innerHTML : '';
            const btnEl = card.querySelector('.dj-card-add-btn');
            const variantId = btnEl ? btnEl.dataset.variantId : '';

            // Randomize badge shape
            const badges = [
                window.djGiftMachineAssets?.badgeTriangle || '',
                window.djGiftMachineAssets?.badgeBlob || '',
                window.djGiftMachineAssets?.badgeSquare || ''
            ];
            const badgeSvgUrl = badges[i % badges.length];

            // Construct p-card HTML
            const pCard = document.createElement('div');
            pCard.className = 'p-card';
            pCard.style.opacity = '0';
            pCard.style.transform = 'translateY(20px)';
            pCard.style.transition = 'all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1)';

            pCard.innerHTML = `
                <div class="p-img-box">
                    <a href="${url}"><img src="${imgSrc}" alt="${title}"></a>
                    ${badgeSvgUrl ? `<div class="p-char-badge"><img src="${badgeSvgUrl}" alt="badge"></div>` : ''}
                </div>
                <div class="p-body">
                    <div class="p-meta"><span class="p-age">${vendor}</span></div>
                    <h3 class="p-name"><a href="${url}" style="text-decoration:none; color:inherit;">${title}</a></h3>
                    <div style="flex:1;"></div>
                    <div class="p-footer">
                        <div class="p-price">${priceHtml}</div>
                        <button class="btn-buy" data-variant-id="${variantId}">Comprar regalo</button>
                    </div>
                </div>
            `;

            container.appendChild(pCard);
            
            // Bind Add to Cart
            const newBtn = pCard.querySelector('.btn-buy');
            if (newBtn && variantId) {
                newBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    if(typeof handlePremiumAddToCart === 'function') {
                        handlePremiumAddToCart(e, newBtn, variantId);
                    } else {
                        this.addToCart(variantId);
                    }
                });
            }

            // Intercept clicks to open Detail Screen
            const productData = { title, url, imgSrc, vendor, priceHtml, variantId };
            const imgLink = pCard.querySelector('.p-img-box a');
            const titleLink = pCard.querySelector('.p-name a');
            
            if (imgLink) {
                imgLink.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.showDetailScreen(productData);
                });
            }
            if (titleLink) {
                titleLink.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.showDetailScreen(productData);
                });
            }

            // Animate entrance
            setTimeout(() => {
                pCard.style.opacity = '1';
                pCard.style.transform = 'translateY(0)';
            }, 50 * (i - start));
        }

        this.resultsRenderedCount = end;
        this.resultsLoadCount++;

        // Update count text
        if (resultsCountText) {
            resultsCountText.textContent = `${this.resultsRenderedCount} tesoro${this.resultsRenderedCount !== 1 ? 's' : ''}`;
        }

        // Check if we can load more
        if (this.resultsRenderedCount >= this.resultsCache.length || this.resultsLoadCount > this.resultsMaxLoads) {
            if (loadMoreContainer) loadMoreContainer.style.display = 'none';
        } else {
            if (loadMoreContainer) {
                loadMoreContainer.style.display = 'flex';
                // Scroll down slightly if not first load
                if (this.resultsLoadCount > 1) {
                    setTimeout(() => {
                        loadMoreContainer.scrollIntoView({ behavior: 'smooth', block: 'end' });
                    }, 100);
                }
            }
        }
    }

    showDetailScreen(data) {
        const resultsEl = this.section.querySelector('#screen-results');
        const detailEl = this.section.querySelector('#screen-detail');
        if (!detailEl || !resultsEl) return;

        // Populate data
        const titleEl = this.section.querySelector('#gm-detail-title');
        if(titleEl) titleEl.textContent = data.title;
        
        const vendorEl = this.section.querySelector('#gm-detail-vendor');
        if(vendorEl) vendorEl.textContent = data.vendor;
        
        const priceEl = this.section.querySelector('#gm-detail-price');
        if(priceEl) priceEl.innerHTML = data.priceHtml;
        
        const imgEl = this.section.querySelector('#gm-detail-img');
        if(imgEl) imgEl.src = data.imgSrc;
        
        const buyBtn = this.section.querySelector('#gm-detail-buy-btn');
        if(buyBtn) buyBtn.dataset.variantId = data.variantId;
        
        // Reset desc
        const descEl = this.section.querySelector('#gm-detail-desc');
        if(descEl) descEl.innerHTML = 'Cargando los secretos de este tesoro...';

        // Fetch detailed product data
        if (data.url && data.url !== '#') {
            const jsonUrl = data.url.split('?')[0] + '.js';
            fetch(jsonUrl)
                .then(r => r.json())
                .then(product => {
                    if(descEl) descEl.innerHTML = product.description || 'Una joya lista para ser descubierta.';
                }).catch(err => {
                    if(descEl) descEl.innerHTML = 'Una joya lista para ser descubierta.';
                });
        }

        // Setup buy button listener (clone to remove old listeners)
        if (buyBtn) {
            const newBuyBtn = buyBtn.cloneNode(true);
            buyBtn.parentNode.replaceChild(newBuyBtn, buyBtn);
            newBuyBtn.addEventListener('click', (e) => {
                e.preventDefault();
                if(typeof handlePremiumAddToCart === 'function') {
                    handlePremiumAddToCart(e, newBuyBtn, data.variantId);
                } else {
                    this.addToCart(data.variantId);
                }
            });
        }

        // Animate transition to detail screen
        detailEl.style.transform = 'translateX(40px)';
        detailEl.offsetHeight; // reflow
        detailEl.style.transform = '';
        
        resultsEl.classList.remove('active');
        resultsEl.classList.add('exit');
        setTimeout(() => resultsEl.classList.remove('exit'), 320);
        
        detailEl.classList.add('active');
        
        // Scroll to top of app shell
        this.section.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    hideDetailScreen() {
        const resultsEl = this.section.querySelector('#screen-results');
        const detailEl = this.section.querySelector('#screen-detail');
        if (!detailEl || !resultsEl) return;

        resultsEl.style.transform = 'translateX(-40px)';
        resultsEl.offsetHeight; // reflow
        resultsEl.style.transform = '';
        
        detailEl.classList.remove('active');
        
        resultsEl.classList.add('active');
    }

    addToCart(variantId) {
        let formData = { 'items': [{ 'id': variantId, 'quantity': 1 }] };
        
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
        })
        .then(response => response.json())
        .then(data => {
            if (typeof openCart === 'function') {
                openCart();
            } else if (window.Theme && window.Theme.cart) {
                window.Theme.cart.update();
            } else {
                window.location.href = '/cart';
            }
        })
        .catch((error) => {
            console.error('Error adding to cart:', error);
        });
    }

    restart() {
        this.section.querySelectorAll('.opt-card.selected').forEach(c => c.classList.remove('selected'));
        const fill = this.section.querySelector('#gm-pb-fill');
        if (fill) fill.style.width = '0%';
        this.historyTracker = [];
        this.selections = {};
        this.showStep(0, 'back');
    }
}

// Global initialization
document.addEventListener('DOMContentLoaded', () => {
    const gmContainer = document.querySelector('[data-gift-machine-id]');
    if (gmContainer) {
        window.giftMachine = new GiftMachine(gmContainer.dataset.giftMachineId);
    }
});
